/*
 * Copyright (c) ProviderTrust LLC.
 * All Rights Reserved.
 *
 * This software is confidential and proprietary information of
 * ProviderTrust LLC ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with ProviderTrust.
 */

import { mapGetters, mapMutations } from "vuex"
import axios from "axios"
import analytics from "@/service/analytics"

export default {
  data() {
    return {
      creatingUser: false,
      errorMessage: null
    }
  },

  computed: mapGetters(["creationRequest"]),

  methods: {
    ...mapMutations(["updateErrorData", "updateCurrentStep"]),

    createUser: function() {
      this.creatingUser = true
      this.errorMessage = null
      this.updateErrorData(null)

      axios
        .post(
          `/services/account?deviceId=${analytics.deviceId()}`,
          this.creationRequest
        )
        .then(
          response => {
            this.updateCurrentStep(4)
            this.creatingUser = false
            return response
          },
          error => {
            if (error.response.data.userCreationError === "CLIENT_CREATION") {
              this.errorMessage =
                "There was an error creating your account. Please try again later."
              window.scrollTo(0, 0)
            } else {
              this.updateErrorData(error.response.data)
              this.updateCurrentStep(2)
            }

            this.creatingUser = false
            return error
          }
        )
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/createUser.js